module.exports = __webpack_public_path__ + "static/img/8.b04053a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/aboutUs/companys/8.png
// module id = V4y2
// module chunks = 1